export default __webpack_public_path__ + "static/media/default-avatar.4f9ba665.svg";